import { StyledEngineProvider, ThemeProvider as ThemeProviderMaterial } from "@mui/material/styles";
import { ThemeProviderProps } from "./types";
import { lightTheme } from "./themes/light";

const ThemeProvider = ({ children, theme = lightTheme }: ThemeProviderProps) => {
  return (
    <ThemeProviderMaterial theme={theme}>
      <StyledEngineProvider injectFirst>{children}</StyledEngineProvider>
    </ThemeProviderMaterial>
  );
};

export default ThemeProvider;
